var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 70C54.3298 70 69.9998 54.3299 69.9998 35C69.9998 15.6701 54.3298 0 34.9998 0C15.6699 0 0 15.6701 0 35C0 54.3299 15.6699 70 34.9998 70Z",
    fill: "#004077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6567 35.8755V44.5191",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9722 40.2036H39.3286",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.224 34.4899L49.2726 34.4293H49.2483C50.5613 32.6665 51.2176 30.3932 50.6584 27.9131C49.9898 24.9347 47.5707 22.5154 44.5679 21.9075C39.4863 20.8985 35.0124 24.7644 35.0124 29.6758C35.0124 24.7644 30.5508 20.8985 25.457 21.9075C22.4421 22.5154 20.0228 24.9347 19.3663 27.9131C18.8071 30.3932 19.4636 32.6665 20.7766 34.4293H20.7523L33.8088 49.6742C34.441 50.4036 35.5959 50.4036 36.2281 49.6742L38.4894 47.0239",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon6);
export default __webpack_public_path__ + "static/media/home-icon-6.faf18af1a5e1b8bbc16bb8396156780e.svg";
export { ForwardRef as ReactComponent };